<rh-header-suggestions [searchValue]="searchValue" (selected)="closeSuggestions.emit()" width="100%"></rh-header-suggestions>
